import { render, staticRenderFns } from "./UnidadesConservacao.vue?vue&type=template&id=03ddb9d0&lang=pug"
import script from "./UnidadesConservacao.vue?vue&type=script&lang=js"
export * from "./UnidadesConservacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports